import React, { useEffect, useLayoutEffect } from "react";
import MainContainer from "../../../components/container/MainContainer";
import AddResource from "../../../components/header/AddResource";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addProblemStatementSummary,
  getProject,
} from "../../../features/projectsSlice";
import Loading from "../../../components/loading/Loading";
import InputField from "../../../components/form/InputField";
import ItemContainer from "../../../components/form/ItemContainer";
import TextContainer from "../../../components/text/TextContainer";
import { useNotification } from "../../../components/notification/NotificationContainer";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const ProblemStatementSummary = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const project = useSelector((state) => state.projects.selected);
  const projectLoad = useSelector((state) => state.projects.load.getProject);
  const problemStatLoad = useSelector(
    (state) => state.projects.load.addProblemStatementSummary
  );
  const addNotification = useNotification();
  const {
    register,
    reset,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      const res = await dispatch(addProblemStatementSummary(data));
      if (addProblemStatementSummary.fulfilled.match(res)) {
        addNotification("Submitted Successfylly!", "success");
        return navigate("/requests/problem-statement/success/" + project.id);
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    if (!project.id) {
      dispatch(getProject(id));
    }
  }, []);

  useLayoutEffect(() => {
    if (project.id) {
      reset({
        id: project.id,
      });
    }
  }, [project]);

  if (
    (id && project.id && project.stage.step_number < 1) ||
    (id && project.id && project.stage.step_number > 3)
  ) {
    return navigate("/requests/my-requests");
  }

  if (projectLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <div className="w-full max-w-5xl mx-auto">
        <AddResource title="Application - Need Assessment" />
        {project.id && (
          <form
            onSubmit={(e) => handleSubmit(onSubmit)(e)}
            method="post"
            encType="multipart/form-data"
          >
            <div className="text-text-1/70  border border-bkg2 rounded-md p2 flex flex-col gap-1.5 p-5 mb-4 font-roboto">
              <h5 className="text-text-1/80 ">Problem Statement - Summary</h5>
              <TextContainer
                label="Name of Community"
                content={project.community}
              />
              <TextContainer
                label="Address 1"
                content={project.community_address1}
              />
              <TextContainer
                label="Address 2"
                content={project.community_address2}
              />
              <TextContainer label="Province" content={project.province} />
              <TextContainer label="Country" content={project.country} />
              <TextContainer label="Email" content={project.creator.email} />
              <TextContainer
                label="Email"
                content={project.creator.phone || "---------"}
              />
            </div>

            {/* End of First Div */}

            <div className="text-text-1/60  border border-bkg2 rounded-md p2 flex flex-col gap-1.5 p-5 mb-4 bg-content">
              <TextContainer
                label="Analysis of Existing Situation"
                content={project.analysis}
                isHTML
              />
              <TextContainer
                label="problem Statement"
                content={project.problem_statement}
                isHTML
              />
              <TextContainer
                label="Proposed Solution Idea"
                content={project.proposed_solution}
                isHTML
              />
              {project.supporting_docs && (
                <div>
                  <Link
                    className="hover:text-primary text-primary/85 "
                    to={project.supporting_docs}
                    target="_blank"
                  >
                    Existing Supporting Documents Link
                  </Link>
                </div>
              )}
              <InputField
                register={register}
                name="id"
                type="hidden"
                defaultValue={id}
              />
              <div className="flex justify-between items-center pt-4 pb-10">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    // dispatch(unsetSelectedProject());
                    navigate("/requests/problem-statement/" + project.id);
                  }}
                  className="cancel-rss-btn"
                  disabled={problemStatLoad}
                >
                  Back
                </button>
                <button
                  type="submit"
                  disabled={problemStatLoad}
                  className="add-rss-btn"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </MainContainer>
  );
};

export default ProblemStatementSummary;
